module.exports = __webpack_public_path__ + "static/media/001-balloon-yellow.5268c4db.svg";